"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagsSchema = exports.tagSchema = void 0;
const zod_1 = require("zod");
exports.tagSchema = zod_1.z.string().min(1).max(25).describe("Tag with max. 25 characters");
exports.tagsSchema = zod_1.z.array(exports.tagSchema).min(1).describe("Ordered list of tags");
